import { render, staticRenderFns } from "./MeldformulierSexueleIntimidatieOverig.vue?vue&type=template&id=48adbdf4&scoped=true&"
import script from "./MeldformulierSexueleIntimidatieOverig.vue?vue&type=script&lang=js&"
export * from "./MeldformulierSexueleIntimidatieOverig.vue?vue&type=script&lang=js&"
import style0 from "./MeldformulierSexueleIntimidatieOverig.vue?vue&type=style&index=0&id=48adbdf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48adbdf4",
  null
  
)

export default component.exports